/**
 * talepKaynagi.js — who entered a request (backlog #462, 2026-10-20; backend #454).
 *
 * Every request the backend sends says who entered its CONTENT last: `kaynak` = KATILIMCI | DEKORATOR (a company on the stand, by its role on THAT stand) |
 * ORGANIZATOR (an organizer company, through TALEP_EKLE) | PERSONEL (SAKA staff), `kaynakFirmaId` and `kaynakFirmaAdi` (null for staff and for an unknown
 * source). `kaynak` null = unknown: a request from before V100. An approval or a withdrawal does not change it; the earlier writers are in the history
 * (#452 / #453). The two request lists also take `kaynak=` (one value, or several separated by commas); FIRMA = KATILIMCI + DEKORATOR.
 *
 * Pure helpers, no React: the badge is TalepKaynagi.jsx, the filter is talepFiltreleri.js.
 */

/** The four sources, in the order they are listed and sorted. */
export const KAYNAKLAR = ['KATILIMCI', 'DEKORATOR', 'ORGANIZATOR', 'PERSONEL'];

/** What the list filter may ask for: the four sources and FIRMA (Katılımcı + Dekoratör). */
export const KAYNAK_FILTRELERI = ['FIRMA', ...KAYNAKLAR];

export const kaynakGecerli = (kaynak) => KAYNAKLAR.includes(kaynak);
export const kaynakFiltresiGecerli = (kaynak) => KAYNAK_FILTRELERI.includes(kaynak);

const sira = (kaynak) => (kaynakGecerli(kaynak) ? KAYNAKLAR.indexOf(kaynak) : KAYNAKLAR.length);

/**
 * The requests a stand row of the request lists actually has (the technical ones, the services, the work permits and the equipment one), the same
 * `hasRequest` rule the lists use to draw a badge.
 */
export function standTalepleri(s) {
  const hepsi = [...(s?.teknik ?? []), ...(s?.hizmet ?? []), ...(s?.isIzin ?? []), ...(s?.ekipman ? [s.ekipman] : [])];
  return hepsi.filter((t) => t && t.hasRequest);
}

/**
 * The distinct sources of a set of requests as [{ kaynak, firmaAdi }], in the fixed source order (then by company name). An unknown source is ONE entry
 * { kaynak: null, firmaAdi: null }; a source that is not one of the four counts as unknown.
 */
export function talepKaynaklari(talepler) {
  const gorulen = new Map();
  for (const t of talepler || []) {
    const kaynak = kaynakGecerli(t?.kaynak) ? t.kaynak : null;
    const firmaAdi = kaynak ? (t.kaynakFirmaAdi || null) : null;
    const anahtar = `${kaynak ?? ''}|${firmaAdi ?? ''}`;
    if (!gorulen.has(anahtar)) gorulen.set(anahtar, { kaynak, firmaAdi });
  }
  return [...gorulen.values()].sort((a, b) => sira(a.kaynak) - sira(b.kaynak) || String(a.firmaAdi ?? '').localeCompare(String(b.firmaAdi ?? '')));
}

/**
 * Was this request's content last entered by somebody other than the viewer's company? True for SAKA staff, for another company and for a company source
 * that cannot be compared (no company id); false when it is the viewer's own company, and for an unknown source (nothing to say). Used for the notice
 * "the earlier values stay in the history" (#462): an organizer who edits what a company entered, or the reverse, overwrites it.
 */
export function baskaTarafGirdi(talep, benimFirmaId) {
  if (!talep || !kaynakGecerli(talep.kaynak)) return false;
  if (talep.kaynak === 'PERSONEL') return true;
  if (talep.kaynakFirmaId == null || benimFirmaId == null) return true;
  return Number(talep.kaynakFirmaId) !== Number(benimFirmaId);
}
